<template>
  <div
    class="clearfix big_screen"
    v-loading.fullscreen.lock="loading"
    :style="{height:stepBodyHeight}"
  >
    <header class="site-header">
      <img style="width: 100%" :src="require('@/assets/img/bigScreen/title2.png')" alt />
      <h2>{{title}}</h2>
      <el-button @click="returnList()" style="position:absolute;top:48px;left:48px;" plain>
        <span class="back_icon"></span>返回
      </el-button>
    </header>
    <div style="clear: both"></div>
    <div class="extract_wrapper" :style="{width:activeStep==6?'1200px':'1000px'}">
      <div class="step_wrapper">
        <div class="step_info">
          <div class="step_default"></div>
          <div class="step_light" :style="{width:((activeStep-1)*160 + 80)+'px'}"></div>
          <div class="step_light_icon" :class="'step_light_'+activeStep"></div>
          <!--                    <span class="step_light_arrow" :class="'step_arrow_move_'+activeStep"></span>-->
          <div
            v-for="(item,index) in stepList"
            :key="index"
            class="step_item"
            :class="[activeStep == item.step?'step_active step_' + item.step:'step_' + item.step]"
          >
            <p :class="[index+1<activeStep?'oldColor':'']">{{item.title}}</p>
            <span class="line_bar"></span>
          </div>
        </div>
      </div>
      <stepOne
        v-if="activeStep==1"
        :loading.sync="loading"
        :activeStep.sync="activeStep"
        :curStep.sync="form.curStep"
        :historyid.sync="form.historyid"
        :taskName.sync="form.workName"
        :supervisionIdsName.sync="form.supervisionIdsName"
        @upDateTaskInfo="upDateTaskInfo"
      ></stepOne>
      <stepTwo
        v-if="activeStep==2"
        :loading.sync="loading"
        :activeStep.sync="activeStep"
        :curStep.sync="form.curStep"
        :historyid.sync="form.historyid"
        :taskName.sync="form.workName"
        :supervisionIdsCode.sync="form.supervisionIdsCode"
        :supervisionIdsName.sync="form.supervisionIdsName"
        @upDateTaskInfo="upDateTaskInfo"
        :tradeId="form.tradeId"
      ></stepTwo>
      <stepThree
        v-if="activeStep==3"
        :loading.sync="loading"
        :activeStep.sync="activeStep"
        :curStep.sync="form.curStep"
        :historyid.sync="form.historyid"
        :extractNum.sync="form.extractNum"
        :taskName.sync="form.workName"
        :supervisionIdsName.sync="form.supervisionIdsName"
        @upDateTaskInfo="upDateTaskInfo"
      ></stepThree>
      <stepFour
        v-if="activeStep==4"
        :loading.sync="loading"
        :activeStep.sync="activeStep"
        :curStep.sync="form.curStep"
        :historyid.sync="form.historyid"
        :extractNum.sync="form.extractNum"
        :taskName.sync="form.workName"
        :supervisionIdsName.sync="form.supervisionIdsName"
        @upDateTaskInfo="upDateTaskInfo"
      ></stepFour>
      <stepFive
        v-if="activeStep==5"
        :loading.sync="loading"
        :activeStep.sync="activeStep"
        :curStep.sync="form.curStep"
        :historyid.sync="form.historyid"
        :taskName.sync="form.workName"
        :groupNum.sync="form.groupNum"
        :supervisionIdsName.sync="form.supervisionIdsName"
        @upDateTaskInfo="upDateTaskInfo"
      ></stepFive>
      <stepSix
        v-if="activeStep==6"
        :loading.sync="loading"
        :activeStep.sync="activeStep"
        :curStep.sync="form.curStep"
        :historyid.sync="form.historyid"
        :extractorName.sync="form.extractorName"
        :extractTime.sync="form.extractTime"
        :taskName.sync="form.workName"
        :supervisionIdsName.sync="form.supervisionIdsName"
        @upDateTaskInfo="upDateTaskInfo"
      ></stepSix>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import {tabsCloseCurrentHandle} from '@/utils/routeTab';
import stepOne from "./step_one";
import stepTwo from "./step_two";
import stepThree from "./step_three";
import stepFour from "./step_four";
import stepFive from "./step_five";
import stepSix from "./step_six";
export default {
  name: "extractIngDetail",
  components: {
    stepOne,
    stepTwo,
    stepThree,
    stepFour,
    stepFive,
    stepSix
  },
  data() {
    return {
      id: "",
      activeStep: 1,
      stepBodyHeight: document.documentElement.clientHeight + "px",
      stepList: [
        { step: 1, title: "填写任务名称" },
        { step: 2, title: "设置项目抽取条件" },
        { step: 3, title: "随机抽取项目" },
        { step: 4, title: "选择执法人员" },
        { step: 5, title: "执法人员随机分组" },
        { step: 6, title: "查看双随机匹配结果" }
      ],
      loading: false,
      title: "黄石市工程建设招标投标领域“双随机一公开”检查",
      form: {
        id: "",
        taskId: "",
        historyid: -1, // -1=新增，0=抽取任务完成 1=已抽取项目
        curStep: 1,
        groupNum: 0,
        workName: "",
        extractCode: "",
        extractTime: "",
        extractNum: 0,
        extractorName: "",
        extractorId: "",
        extractResult: "",
        remark: "",
        supervisionIds: [],
        supervisionIdsCode: [],
        supervisionIdsName: "",
        tradeId:'',
      }
    };
  },
  filters: {},
  created() {
    this.id = this.$route.query && this.$route.query.id;
    this.getDetailById();
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    })
  },
  activated() {
    // $route.query.id为首页通过 url跳转 带过来的参数
  },
  methods: {
    returnList() {
      this.$router.push({
        name: "project_extract_list"
      });
    },

    //列表查看进来根据id查询详情
    getDetailById() {
      if (this.id) {
        this.$httpReq
          .get("/projectDoubleExtract/extracttask/get?id=" + this.id)
          .then(res => {
            if (res.data.code == "1") {
              this.form = { ...res.data.data };
              this.form.supervisionIdsCode =
                res.data.data.supervisionIdsCode &&
                res.data.data.supervisionIdsCode.split(",");
              this.activeStep = res.data.data.curStep;
              return;
            }
            this.$message.error(res.data.msg);
          });
      } else {
        this.activeStep = 1;
      }
    },

    upDateTaskInfo(id) {
      this.id = id || (this.$route.query && this.$route.query.id);
      this.getDetailById();
    },

    // 返回
    back() {
      tabsCloseCurrentHandle();
      this.$router.push({
        name: "busWitness_list"
      });
    }
  },
  deactivated() {}
};
</script>

<style lang="scss" scoped>
.big_screen {
  background: url(../../../../assets/img/bigScreen/bg.png) no-repeat 100% 100%;
  background-size: 100% 100%;
  height: 100%;
  width: 100%;

  /deep/ .bidScreenCheckBox {
    color: #fff;
    background: rgba(49, 150, 250, 0.25);
    display: block;
  }

  /deep/ .el-loading-mask {
    background-color: rgba(49, 150, 250, 0.8);
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 17px;
  }
  /* 滚动槽 */
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  }
  /* 滚动条滑块 */
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: rgba(49, 150, 250, 0.7);
  }
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(49, 150, 250, 0.7);
  }

  /deep/ .el-button--default.is-plain {
    background-color: rgba(0, 193, 255, 0.25);
    color: #ffffff;
    border-color: rgba(0, 193, 255, 1);
  }

  /deep/ .back_icon {
    width: 21px;
    height: 14px;
    display: inline-block;
    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -492px -212px;
  }
  /deep/ .step_light_arrow {
    width: 21px;
    height: 14px;
    display: inline-block;
    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -530px -212px;
    position: absolute;
    top: 32px;
    left: 94px;
  }

  /deep/ .step_arrow_move_1 {
    display: none;
  }

  /deep/ .step_arrow_move_2 {
    top: -7%;
    left: 5%;
    -webkit-animation-delay: 500ms;
    animation-delay: 500ms;
  }

  /deep/ .step_arrow_move_1 {
    animation: moving 2s ease-in-out infinite;
  }

  /deep/ .el-button--text {
    span {
      text-decoration: none !important;
      &:hover {
        text-decoration: none !important;
      }
    }
  }

  .site-header {
    height: 15%;
    h2 {
      width: 1200px;
      height: 48px;
      margin: 0px;
      font-size: 48px;
      text-align: center;
      color: #ffffff;
      position: absolute;
      top: 4%;
      left: 50%;
      margin-left: -600px; /* 宽度的一半 */
    }
  }
  .extract_wrapper {
    width: 1000px;
    margin: 0px auto;
    margin-top: 16px;
    height: calc(85% - 16px);
    .step_wrapper {
      width: 100%;
      height: 130px;

      .step_info {
        position: relative;
        width: 880px;
        height: 130px;
        margin: 0 auto;
        .step_default {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100%;
          height: 80px;
          background: url(../../../../assets/img/bigScreen/elves.png) no-repeat
            0px 0px;
        }
        .step_light {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100%;
          height: 80px;
          background: url(../../../../assets/img/bigScreen/elves.png) no-repeat
            0px -80px;
        }
        .step_light_icon {
          width: 80px;
          height: 80px;
          position: absolute;
        }
        .step_light_1 {
          left: -2px;
          background: url(../../../../assets/img/bigScreen/elves.png) no-repeat
            2px -160px;
        }
        .step_light_2 {
          left: 158px;
          background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -78px -160px;
        }
        .step_light_3 {
          left: 318px;
          background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -158px -160px;
        }
        .step_light_4 {
          left: 478px;
          background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -238px -160px;
        }
        .step_light_5 {
          left: 637px;
          background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -318px -160px;
        }
        .step_light_6 {
          left: 798px;
          background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -398px -160px;
        }

        .step_item {
          width: 160px;
          height: 50px;
          color: rgba(255, 255, 255, 0.85);
          display: inline-block;
          float: left;
          margin-top: 90px;
          text-align: center;
          position: relative;
          p {
            margin: 0px;
          }
          .line_bar {
            width: 110px;
            height: 2px;
            display: inline-block;
          }
        }
        .oldColor{
            color: #00CCFF;
        }
        .step_1 {
          width: 120px;
          text-align: left;
          .line_bar {
            width: 88px;
          }
        }
        .step_6 {
          width: 120px;
          text-align: right;
          p {
            width: 146px;
          }
          .line_bar {
            width: 128px;
            margin-left: 20px;
          }
        }

        .step_active {
          p {
            color: rgba(47, 237, 255, 1);
          }
          .line_bar {
            background: linear-gradient(
              to right,
              rgba(49, 150, 250, 0),
              rgba(47, 237, 255, 1),
              rgba(49, 150, 250, 0)
            );
          }
        }
      }
    }

    .step_content {
      color: #ffffff;
      /deep/ .el-scrollbar__bar,.is-vertical{
         display: none;
         .el-scrollbar__thumb{ display: none;}
      }

      /deep/ .el-form-item__label {
        color: #ffffff;
        padding: 0px;
        font-weight: 500;
      }
      /deep/ .el-form-item__content {
        color: #ffffff;
      }
      /deep/ .el-tag.el-tag--info {
        color: #ffffff;
      }

      /deep/ .el-input__inner {
        background: rgba(49, 150, 250, 0.1);
        color: #ffffff;
        border-color: rgba(49, 150, 250, 1) !important;
      }
      /deep/ .el-range-input {
        background: rgba(49, 150, 250, 0);
        color: #ffffff;
        border-color: rgba(49, 150, 250, 1);
      }

      /deep/ .el-range-separator {
        color: #ffffff;
      }

      /deep/ .el-textarea__inner {
        border-color: rgba(49, 150, 250, 1);
        background: rgba(49, 150, 250, 0.1);
        color: #ffffff;
      }

      /deep/ .el-select {
        .el-tag {
          display: inline-block;
          background-color: rgba(49, 150, 250, 0.25);
          height: 22px;
          .el-tag__close.el-icon-close {
            top: -1px;
          }
        }
        .el-select__input {
          color: #ffffff;
          &::placeholder{
            color:rgba(49, 150, 250, 0.25) !important;;
          }
        }
        /deep/ .el-select__input::placeholder{
          color:rgba(49, 150, 250, 0.25) !important;;
        }
      }

      /deep/ .el-popper {
        background-color: rgba(49, 150, 250, 0.25);
        color: #ffffff;
        .el-select-dropdown__item {
          background-color: rgba(49, 150, 250, 0.25);
          color: #ffffff;
        }
        .popper__arrow{
          border-bottom-color:rgba(49, 150, 250, 0.25) !important;
        }
        .popper__arrow::after{
          border-bottom-color:rgba(49, 150, 250, 0.25) !important;
        }
      }

      /deep/ .el-form-item.is-required:not(.is-no-asterisk) {
        .el-form-item__label-wrap {
          .el-form-item__label:before {
            content: "*";
            color: #00ccff;
            margin-right: 4px;
          }
        }
        .el-form-item__label:before {
          content: "*";
          color: #00ccff;
          margin-right: 4px;
        }
      }

      /*/deep/ .el-form-item.is-required:not(.is-no-asterisk){*/
      /*    .el-form-item__label-wrap{*/
      /*        .el-form-item__label:after{*/
      /*            content: '*';*/
      /*            color: #00CCFF;*/
      /*            margin-left: 4px;*/
      /*        }*/
      /*    }*/
      /*    .el-form-item__label:after{*/
      /*        content: '*';*/
      /*        color: #00CCFF;*/
      /*        margin-left: 4px;*/
      /*    }*/
      /*}*/

      /deep/ .el-form-item.is-required:not(.is-no-asterisk) {
        .el-form-item__label-wrap {
          .el-form-item__label:before {
          }
        }
      }
      /deep/ .el-input-number.is-without-controls {
        position: relative;
        .el-input__inner {
          padding-left: 8px;
          padding-right: 8px;
        }
      }
      /deep/ .el-input-number.is-controls-right {
        position: relative;
        .el-input__inner {
          padding-left: 8px;
          padding-right: 24px;
        }

        .el-input-number__increase {
          background: rgba(49, 150, 250, 0.1);
          color: #ffffff;
          border-color: rgba(49, 150, 250, 1);
          width: 24px;
          line-height: 16px;
          &:hover {
            color: rgba(0, 204, 255, 1);
          }
        }

        .el-input-number__decrease {
          background: rgba(49, 150, 250, 0.1);
          color: #ffffff;
          width: 24px;
          border-color: rgba(49, 150, 250, 1);
          line-height: 16px;
          bottom: 2px;
          &:hover {
            color: rgba(0, 204, 255, 1);
          }
        }
        .el-input-number__decrease.is-disabled {
          color: rgba(255, 255, 255, 0.45);
          &:hover {
            color: rgba(255, 255, 255, 0.45);
          }
        }
        .el-input-number__increase.is-disabled {
          color: rgba(255, 255, 255, 0.45);
          &:hover {
            color: rgba(255, 255, 255, 0.45);
          }
        }
      }
      /deep/ .el-select-dropdown {
        background-color: rgba(49, 150, 250, 0.25);
        border-color: rgba(49, 150, 250, 1);
      }
      /deep/ .el-select-dropdown__item.selected {
        color: #ffffff;
      }
      /deep/ .el-select-dropdown__item.hover,
      .el-select-dropdown__item:hover {
        background-color: rgba(49, 150, 250, 1) !important;
        color: #ffffff;
      }
      /*/deep/ .el-select-dropdown__item:hover{*/
      /*    background-color:rgba(49, 150, 250, 1) !important;*/
      /*    color: #FFFFFF;*/
      /*}*/

      /deep/ .el-button--primary.is-plain {
        background-color: rgba(49, 150, 250, 1);
        color: #ffffff;
        border-color: rgba(49, 150, 250, 1);
      }

      /deep/ .el-button--default.is-plain {
        background-color: rgba(0, 193, 255, 0.2);
        color: #ffffff;
        border-color: rgba(0, 193, 255, 1);
      }
      /deep/ .el-button--default.is-plain.is-disabled {
        background-color: rgba(0, 193, 255, 0.25);
        color: rgba(255, 255, 255, 0.8);
        border-color: rgba(0, 193, 255, 1);
      }
      /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #ffffff;
      }
      /deep/ .el-radio {
        color: #ffffff;
      }

      /deep/ .el-button.start-extract-btn {
        padding: 12px 26px;
        background: linear-gradient(to bottom, #5fc7fd, #3196fa);
      }
      /deep/ .el-button.start-extract-btn.is-disabled {
        opacity: 0.45;
      }

      /deep/ .el-button--text {
        color: rgba(0, 204, 255, 1);
      }
      /deep/ .el-button--text.is-disabled {
        color: rgba(49, 150, 250, 0.8);
      }

      /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
        margin-bottom: 0px !important;
      }
     
      /deep/ .input-slot-box {
        position: relative;
        display: inline-block;
        .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }

      /deep/ .el-input-icon {
        display: inline-block;
        height: 32px;
        text-align: center;
        line-height: 32px;
        background-color: rgba(49, 150, 250, 0.15);
        color: rgba(255, 255, 255, 0.45);
        border: 1px solid rgba(49, 150, 250, 1);
        position: absolute;
        top: 2px;
        border-left: none;
        border-radius: 0 4px 4px 0;
      }

      /deep/ .el-input-icon.el-input-icon-ie {
        top: 1px;
      }

      /deep/ .el-input-slot {
        width: 30px;
        right: 0px;
      }
      /deep/ .el-input-slot2 {
        width: 40px;
        position: absolute;
        right: 2px;
      }

      /deep/ .el-loading-spinner {
        .path {
          stroke: #ffffff;
        }
      }

      /deep/ .bigScreenTable.el-table {
        background: rgba(49, 150, 250, 0.1);
        color: #ffffff;
        border-color: rgba(49, 150, 250, 1);
        th,
        tr {
          background: rgba(49, 150, 250, 0.1);
          color: #ffffff;
          border-color: rgba(49, 150, 250, 1);
        }
        tr.hover_row > td {
          background: rgba(49, 150, 250, 0.25) !important;
          border-color: rgba(49, 150, 250, 1) !important;
        }
        th.is-leaf {
          border-color: rgba(49, 150, 250, 1);
        }
        td {
          color: #ffffff;
          background: rgba(49, 150, 250, 0.1) !important;
          border-color: rgba(49, 150, 250, 1) !important;
        }
        .el-table--border::after,
        .el-table--group::after,
        .el-table::before {
          border-color: rgba(49, 150, 250, 1);
        }
      }

      /*/deep/ .el-button.is-plain:focus, .el-button.is-plain:hover{*/
      /*    border-color:#FFFFFF;*/
      /*}*/

      /deep/ .btn_wraper {
        text-align: center;
        position: relative;
        .supervisionNameInfo {
          position: absolute;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 200px;
          margin: 0;
          top: -4px;
          right: 44px;
          height: 24px;
          line-height: 24px;
          color: rgba(255, 255, 255, 0.65);
        }
      }
    }
  }

  /deep/ .operation_wrapper {
    margin: 12px auto;
    margin-bottom: 24px;
    padding: 16px 24px;
    background: rgba(0, 153, 255, 0.1);
    border: 2px solid rgba(49, 150, 250, 1);
    position: relative;
    text-align: center;
    .el-form {
      text-align: left;
    }
    .task-name-info {
      text-align: left;
      margin-top: 0;
      margin-bottom: 32px;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: white;
    }

    .step_icon {
      width: 40px;
      height: 20px;
      position: absolute;
      display: inline-block;
    }

    .border_leftT {
      background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -482px -171px;
      left: -2px;
      top: -2px;
    }

    .border_rightT {
      background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -518px -171px;
      right: -2px;
      top: -2px;
    }

    .border_leftB {
      background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -600px -171px;
      left: -4px;
      bottom: -4px;
    }

    .border_rightB {
      background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -560px -171px;
      right: -4px;
      bottom: -4px;
    }
  }

  /deep/ .role_table {
    width: 100%;
    padding: 0;
    margin: 0;
    border: 1px solid rgba(49, 150, 250, 1);
    border-spacing: 0;
    border-collapse: collapse;
    text-align: center;
    th {
      border: 1px solid rgba(49, 150, 250, 1);
      padding: 4px 8px;
      margin: 0;
      height: 44px;
      border-spacing: 0;
      border-collapse: collapse;
      color: #ffffff;
    }
    td {
      padding: 4px 8px;
      margin: 0;
      height: 44px;
      border-collapse: collapse;
      border-spacing: 0;
      border: 1px solid rgba(49, 150, 250, 1);
      p {
        margin: 0;
      }
    }
  }

  /deep/ .link_info {
    color: rgba(0, 204, 255, 1);
  }

  /deep/ .el-dialog {
    background: #0057ac;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
    color: #ffffff;
    .el-dialog__header {
      border-bottom: 1px solid rgba(255, 255, 255, 0.25);
    }
    .el-dialog__title {
      color: #ffffff;
    }
    .dialog-content {
      border-top: 2px solid rgba(255, 255, 255, 0.25);
      border-bottom: 2px solid rgba(255, 255, 255, 0.25);
    }
    .dialog-content aside {
      border-right: 2px solid rgba(255, 255, 255, 0.25);
    }
    .dialog-content .dialog-right-content .dialog-right-content-title {
      border-bottom: 2px solid rgba(255, 255, 255, 0.25);
    }
    .dialog-content .dialog-right-content {
      border-left: 2px solid rgba(255, 255, 255, 0.25);
    }
    .dialog-content aside .aside-select-list .list-item p {
      color: #ffffff !important;
    }
    .dialog-right-content-title {
      span {
        color: #ffffff !important;
      }
    }

    .el-button {
      background: rgba(49, 150, 250, 0.25);
      border-radius: 2px;
      border: 1px solid #3196fa;
      color: #ffffff;
    }
    .el-button--text {
      border: none !important;
      span {
        text-decoration: none !important;
        &:hover {
          text-decoration: none !important;
        }
      }
    }
    .el-dialog__headerbtn .el-dialog__close,
    .el-checkbox {
      color: #ffffff;
    }
    .el-table,
    .el-table th,
    .el-table tr {
      background-color: #0057ac !important;
    }
    .el-table::before,
    .el-table--border::after,
    .el-table th.el-table__cell,
    .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
      background-color: #3196fa;
    }
    .el-table--border {
      border-color: #3196fa;
    }
    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
      border-bottom: 1px solid #3196fa;
      color: #ffffff;
      background-color: #0057ac !important;
    }
    .el-table--border .el-table__cell,
    .el-table__body-wrapper
      .el-table--border.is-scrolling-left
      ~ .el-table__fixed {
      border-right: 1px solid #3196fa;
    }
    .el-pagination {
      margin-top: 15px;
      .el-pagination__total {
        color: #ffffff !important;
      }
    }
    .btn-prev,
    .btn-next,
    .el-pagination.is-background .el-pager li:not(.active) {
      background-color: #1f6bb5 !important;
      color: #ffffff !important;
    }
  }
}

@media screen and(max-width: 1440px) {
  .big_screen {
    .site-header {
      h2 {
        top: 24px;
      }
    }
  }
}

@-webkit-keyframes moving {
  0% {
  }
  100% {
  }
}

@keyframes moving {
  0% {
  }
  100% {
  }
}
</style>